// Fixes 'Util is not defined' error
import 'expose-loader?Util!bootstrap/js/dist/util';
import 'perform-base/js/base';
import 'perform-base/js/globals';
import 'perform-base/js/actions';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';

import accountDetails from './account-details.js';
import accountEdit from './account-edit.js';
import contractView from './contracts/view.js';
import contractWrite from './contracts/write.js';
import createInvoice from './create-invoice';
import createPayment from './create-payment';
import createDeploymentEnvironment from './create-deployment-environment';
import dashboard from './dashboard';
import editProjectWorkTypes from './edit-project-work-types';
import createProject from './create-project.js';
import accounts from './leads.js';
import person from './person.js';
import deploy from './deploy.js';
import notes from './notes.js';
import contactDetails from './contact-details.js';
import roles from './roles.js';
import {copyLoginUrl} from './user';
import subscriptionDates from './subscriptions/dates.js';
import subscriptionDelete from './subscriptions/delete.js';
import {taskView} from './tasks.js';
import {projectView, projectPermissions} from './projects.js';
import {postView} from './posts.js';
import {queryQuickBooks} from './quickbooks.js';
import kanban from './kanban.js';
import {isCtrlOrCmd, copyText} from './utils';

window.Brain = {
  accountDetails,
  accountEdit,
  copyLoginUrl,
  contractView,
  contractWrite,
  createInvoice,
  createPayment,
  createDeploymentEnvironment,
  dashboard,
  deploy,
  editProjectWorkTypes,
  createProject,
  accounts,
  kanban,
  notes,
  person,
  postView,
  projectView,
  projectPermissions,
  subscriptionDates,
  subscriptionDelete,
  contactDetails,
  roles,
  taskView,
  queryQuickBooks,
};

$('form').find('.select2').select2();

$('.copy-link').click(function(e) {
  e.preventDefault();
  copyText($(this).data('text'));
});



// WEBPACK FOOTER //
// ./assets/js/app.js